import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import RangeSlider from "./range_slider/rangeslider";
import { Link } from "react-router-dom";

const ROIAnalysis = () => {
  const [agents, setAgents] = useState(20);
  const [costPerAgent, setCostPerAgent] = useState(5000);
  const [handleTime, setHandleTime] = useState(360);
  const [missedCalls, setMissedCalls] = useState(10);
  const [callsHandled, setCallsHandled] = useState(100);

  const callsPerYear = callsHandled * 365;
  const missedCallsPerYear = missedCalls;

  // Time Invested in Calls
  const totalTimeSpent = agents * handleTime * callsPerYear; // in seconds
  const timeInvestedInHours = totalTimeSpent / 3600; // Convert to hours

  // Money Saved
  const hourlyWage = costPerAgent / 2080; // Assuming 40hrs/week, 52 weeks
  const agentsReduced = Math.max(0, Math.floor(agents * 0.2)); // Assume 20% reduction with AI
  const reducedAHT = handleTime * 0.1; // Assume 10% reduction
  const moneySaved =
    agentsReduced * costPerAgent +
    (reducedAHT / 3600) * hourlyWage * callsPerYear;

  // Lost Revenue from Missed Calls
  const potentialRevenuePerCall = 50; // Assume $50 per missed call
  const lostRevenue = missedCallsPerYear * potentialRevenuePerCall;

  return (
    <Container fluid className="text-light roi-container anybody-font">
      <div className="container">
        <div
          className="d-flex align-items-center flex-md-row flex-column"
          style={{ marginBottom: "64px" }}
        >
          <Col className="text-left px-0" xs={12} md={8} lg={8}>
            <div
              className="badge-base d-inline-block fs-one mb-4 fw-bold"
              style={{ lineHeight: "20px" }}
            >
              ROI - Deep Analysis
            </div>{" "}
            <h2 className="fs-four-title fw-bold mb-4">
              Measure the impact of AI on your business.
            </h2>
            <p className="fs-two mb-0 body-font fw-normal">
              With customizable inputs and dynamic data visualizations, gain
              clear insights into customer experience, workforce effectiveness,
              operational efficiency, and business growth.
            </p>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            className="px-0 d-flex justify-content-center justify-content-md-start"
          >
            <Image src="assets/deep-analysis-bar-chart.svg" fluid />
          </Col>
        </div>
        <div
          className={`custom-rounded w-100 bg-light-avg`}
          style={{
            paddingBottom: "32px",
          }}
        >
          <div className="px-3 d-flex w-100 flex-md-row flex-column">
            <div
              className="text-dark roi-result-section"
              style={{ marginRight: "16px" }}
            >
              {/* Contact Center Agents */}
              <Card
                className="border border-0"
                style={{ marginBottom: "20px" }}
              >
                <Card.Body>
                  <RangeSlider
                    label="Total number of contact center agents?"
                    min={5}
                    max={100}
                    step={1}
                    value={agents}
                    onChange={setAgents}
                    unit="Agents"
                    symbol={false}
                  />
                </Card.Body>
              </Card>
              <div
                className="bg-white rounded-1"
                style={{ height: "4px" }}
              ></div>

              {/* Cost per Agent Annually */}
              <Card
                className="border border-0"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                <Card.Body>
                  <RangeSlider
                    label="Cost per agent annually?"
                    min="1"
                    max="100000"
                    step="10"
                    value={costPerAgent}
                    onChange={setCostPerAgent}
                    // unit="K"
                    dollor={true}
                    symbol={false}
                  />
                </Card.Body>
              </Card>
              <div
                className="bg-white rounded-1"
                style={{ height: "4px" }}
              ></div>

              {/* Average Handle Time per Call */}
              <Card
                className="border border-0"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                <Card.Body>
                  <RangeSlider
                    label="Average handle time per call?"
                    min="30"
                    max="1200"
                    value={handleTime}
                    onChange={setHandleTime}
                    step={30}
                    unit="Sec"
                    symbol={false}
                  />
                </Card.Body>
              </Card>
              <div
                className="bg-white rounded-1"
                style={{ height: "4px" }}
              ></div>

              {/* Average Number of Missed Calls */}

              <Card
                className="border border-0"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                <Card.Body>
                  <RangeSlider
                    label="Average number of missed calls?"
                    min="0"
                    max="90"
                    value={missedCalls}
                    onChange={setMissedCalls}
                    step={1}
                    symbol={false}
                  />
                </Card.Body>
              </Card>
              <div
                className="bg-white rounded-1"
                style={{ height: "4px" }}
              ></div>

              {/* Average Number of Missed Calls */}

              <Card className="border border-0" style={{ marginTop: "20px" }}>
                <Card.Body>
                  <RangeSlider
                    label="Average number of calls handled per day?"
                    min="10"
                    max="500"
                    value={callsHandled}
                    onChange={setCallsHandled}
                    step={10}
                    symbol={false}
                  />
                </Card.Body>
              </Card>
            </div>
            <div className="bg-white rounded-1" style={{ width: "4px" }}></div>
            {/* Results */}
            <div
              className="roi-result-section bg-light-avg roi-result-section-small"
              style={{
                marginLeft: "16px",
              }}
            >
              <Card
                className="border border-0 roi-result-subsection"
                style={{ marginBottom: "20px" }}
              >
                <Card.Body className="w-100 p-0 gap-3 d-flex flex-column justify-content-center align-items-center">
                  <p
                    className="mb-0 fs-three-title fw-bold text-center roi-lineheight"
                    style={{ marginTop: "38px" }}
                  >
                    You Save
                  </p>
                  <div className="roi-result-value text-center d-flex w-100 flex-column bg-light-avg justify-content-center align-items-center">
                    <p className="fw-bold mb-0 fs-four-title pure-black-color roi-lineheight">
                      ${(moneySaved / 12).toFixed(1).toLocaleString()}
                    </p>
                    <p
                      className="mb-0 fs-one mb-0 body-font"
                      style={{ lineHeight: "20px" }}
                    >
                      in costs per month
                    </p>
                  </div>

                  <p
                    className="fs-6 fw-normal body-font text-center"
                    style={{ marginBottom: "38px" }}
                  >
                    With Nouraa you can save
                  </p>
                </Card.Body>
              </Card>
              <div
                className="bg-white rounded-1"
                style={{ height: "4px" }}
              ></div>

              <Card
                className="border border-0 roi-result-subsection"
                style={{ marginBottom: "20px", marginTop: "20px" }}
              >
                <Card.Body className="w-100 p-0 gap-3 d-flex flex-column justify-content-center align-items-center">
                  <p
                    className="mb-0 fs-three-title fw-bold text-center roi-lineheight"
                    style={{ marginTop: "38px" }}
                  >
                    Time Invested in Calls
                  </p>
                  <div
                    className="roi-result-value text-center d-flex w-100 flex-column bg-light-avg justify-content-center align-items-center"
                    style={{ padding: "20px 40px", borderRadius: "14px" }}
                  >
                    <p className="fw-bold mb-0 fs-four-title pure-black-color roi-lineheight">
                      {Number(
                        (timeInvestedInHours / 12).toFixed(1)
                      ).toLocaleString()}{" "}
                    </p>
                    <p
                      className="mb-0 fs-one mb-0 body-font"
                      style={{ lineHeight: "20px" }}
                    >
                      hours every month
                    </p>
                  </div>

                  <p
                    className="fs-6 fw-normal body-font text-center"
                    style={{ marginBottom: "38px" }}
                  >
                    Nouraa helps in reducing agents workload
                  </p>
                </Card.Body>
              </Card>

              <div
                className="bg-white rounded-1"
                style={{ height: "4px" }}
              ></div>

              <Card
                className="border border-0 roi-result-subsection mb-0"
                style={{ marginTop: "20px" }}
              >
                <Card.Body className="w-100 p-0 gap-3 d-flex flex-column justify-content-center align-items-center">
                  <p
                    className="mb-0 fs-three-title fw-bold text-center roi-lineheight"
                    style={{ marginTop: "38px" }}
                  >
                    Lost Revenue from Missed Calls
                  </p>
                  <div
                    className="roi-result-value text-center d-flex w-100 flex-column bg-light-avg justify-content-center align-items-center"
                    style={{ padding: "20px 40px", borderRadius: "14px" }}
                  >
                    <p className="fw-bold mb-0 fs-four-title pure-black-color roi-lineheight">
                      ${lostRevenue.toLocaleString()}
                    </p>
                    <p
                      className="mb-0 fs-one mb-0 body-font"
                      style={{ lineHeight: "20px" }}
                    >
                      in costs per month
                    </p>
                  </div>

                  <p className="fs-6 fw-normal body-font roi-lostrevenue">
                    AI can handle missed calls, improving customer retention and
                    revenue
                  </p>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="bg-white rounded-1" style={{ height: "4px" }}></div>
          {/* CTA */}
          <Row className="text-center mx-2" style={{ marginTop: "32px" }}>
            <Col>
              <p className="text-dark fw-bold fs-6">
                AI that cuts costs, enhances efficiency, and transforms customer
                experience
              </p>
              <Button
                className="btn-primary-style fw-bold py-3 px-4 roi-getstarted-button"
                as={Link}
                to="/signup"
              >
                Get Started for Free
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
};

export default ROIAnalysis;
